import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { store } from './_helpers'
import App from './App'
import reportWebVitals from './reportWebVitals'
// 공통으로 사용되는 css
import './custom-btsp.scss'
//import "./assets/css/vendor/bootstrap.min.css";
import GlobalStyle from './components/GlobalStyles'
import { ParallaxProvider } from 'react-scroll-parallax'

ReactDOM.render(
  <Provider store={store}>
    <GlobalStyle />
    <ParallaxProvider>
      <App />
    </ParallaxProvider>
  </Provider>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
